export default {
	alex: {
		general: {
			rules: [
				(x) => {
					if (x.role === 'author' && x.publish_status.key && x.publish_status.key !== 'returned_to_author') {
						x.can_edit = false
					} else if(x.role === 'reviewer' && (x.publish_status.key === 'ready_for_publication' || x.publish_status.key === 'returned_to_author')) {
						x.can_edit = false
					} else if (x.role === 'publisher') {
						x.can_edit = false
					} else {
						x.can_edit = true
					}
				}
			],
			statuses: [{
				key: 'submitted',
				text: 'Submitted'
			},{
				key: 'under_review',
				text: 'Under Review'
			},{
				key: 'returned_to_author',
				text: 'Returned to Author'
			},{
				key: 'ready_for_publication',
				text: 'Ready for Publication'
			},{
				key: 'published',
				text: 'Published'
			},],
			admin_roles: ['reviewer', 'publisher']
		},
		author: [
			{
				key: 'returned_to_author',
				text: 'UnSubmit',
				color: 'red',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'submitted':
							case 'under_review':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: null, text: 'Not Submitted for Publication'})
				},
			},
			{
				key: 'submitted',
				text: 'Submit',
				color: 'orange',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case null:
							case 'returned_to_author':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					if (x.alignment_required && !x.item.standards.length) {
						x.$alert('Alignment to standards required to submit for publication.')
					} else {
						x.set_publish_status({key: 'submitted', text: 'Submitted'})
					}
				},
			},
		],
		reviewer: [
			{
				key: 'rejected',
				text: 'Reject',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'submitted':
							case 'under_review':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: null, text: 'Rejected'})
				},
			},
			{
				key: 'returned',
				text: 'Return to Author',
				color: 'red',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'submitted':
							case 'under_review':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: 'returned_to_author', text: 'Returned to Author'})
				},
			},
			{
				key: 'under_review',
				text: 'Begin Review',
				color: 'yellow',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'submitted':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: 'under_review', text: 'Under Review'})
				},
			},
			{
				key: 'ready_for_publication',
				text: 'Approve for Publication',
				color: 'blue',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'under_review':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: 'ready_for_publication', text: 'Ready for Publication'})
				},
			},
		],
		publisher: [
			{
				key: 'under_review',
				text: 'Return to Reviewer',
				color: 'yellow',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'ready_for_publication':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: 'under_review', text: 'Under Review'})
				},
			},
			{
				key: 'published',
				text: 'Publish',
				color: 'green',
				disabled: false,
				rules: [
					(x) => {
						switch (x.publish_status.key) {
							case 'ready_for_publication':
								return false
							default:
								return true 
						}
					},
				],
				click: (x) => {
					x.set_publish_status({key: 'published', text: 'Published', final: true})
				},
			},
		],
}
}